import styles from './LegalPage.module.scss';

export function LegalPage() {
  return (
    <>
      <title>Юридические документы — Order2Go.ru</title>
      <div className={styles.wrapper}>
        <a
          href="/documents/Политика_обработки_персональных_данных_для_АДВ_на_сайт_ADV.pdf"
          target="_blank"
        >
          Политика обработки персональных данных
        </a>
        <a
          href="/documents/Пользовательское_соглашение_публичная_оферта_для_сайта_АДВ_PARTNER.pdf"
          target="_blank"
        >
          Пользовательское соглашение
        </a>
        <a href="/documents/Публичная_оферта_от_Кафе_PARTNER" target="_blank">
          Публичная оферта
        </a>
        <a
          href="/documents/Согласие_на_обработку_персональных_данных_на_сайте_и_в_мобильном_ADV.pdf"
          target="_blank"
        >
          Согласие на обработку персональных данных
        </a>
      </div>
    </>
  );
}
